import React from 'react';
import './Divider.less';

export type DividerProps = {
  className?: string;
  dashed?: boolean;
  plain?: boolean;
  orientation?: 'left' | 'right' | 'center';
  type?: 'horizontal' | 'vertical';
};

const TDivider: React.FC<DividerProps> = ({
  className,
  dashed,
  plain,
  orientation,
  type = 'horizontal',
}) => {
  const classNames = [
    't-divider',
    dashed && 't-divider-dashed',
    `t-divider-${type}`,
    plain &&
      orientation &&
      `t-divider-with-text t-divider-with-text-${orientation}`,
    className,
  ];
  return <div className={classNames.join(' ')} />;
};

export default TDivider;
